// BrandHeader.js

import React from 'react';

const PrivacyPolicy = (props) => {
  return (
    <div>
        <p>{props.privacyPolicyLabel} <a rel="noopener noreferrer" target="_blank" href={props.privacyPolicyLink}>privacy policy.</a> </p>
    </div>
  );
};

export default PrivacyPolicy;
